import PropTypes from 'prop-types'
import React from 'react'

const ImportIcon = ({
   className,
   color,
   height,
   strokeWidth,
   width
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <line
            fill="none"
            strokeMiterlimit="10"
            x1="12"
            y1="16"
            x2="12"
            y2="3"
         />
         <polyline
            fill="none"
            stroke={color}
            strokeMiterlimit="10"
            points="17,3 23,3 23,21 1,21 1,3 7,3 "
         />
         <polyline
            fill="none"
            strokeMiterlimit="10"
            points=" 17,11 12,16 7,11 "
         />
      </g>
   </svg>
)

ImportIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

ImportIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(ImportIcon)
